import { render, staticRenderFns } from "./PemdaPotonganTable.vue?vue&type=template&id=0a1bfa89&lang=pug"
import script from "./PemdaPotonganTable.vue?vue&type=script&lang=js"
export * from "./PemdaPotonganTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports